export default __webpack_public_path__ + "static/media/skanetrafiken_logotype.acf65d6f.png";